import type { ImprovementAreasModel } from '@quiz/models/ImprovementAreasModel';
import type { IReview, IReviewV3Model } from '@quiz/models/IReview';

export default defineAppConfig({
  reviewsConfigs: {},
  improveAreas: {},
});

declare module '@nuxt/schema' {
  interface AppConfigInput {
    reviewsConfigs?: {
      reviews?: number[]
      reviewsGoals?: number[]
      reviewsList?: Record<number, IReview>
      reviewsListV3?: Record<number, IReviewV3Model>
    }
    improveAreas?: {
      erectile?: ImprovementAreasModel[]
      ejaculation?: ImprovementAreasModel[]
      improve?: ImprovementAreasModel[]
    }
  }
}
